__turbopack_context__.v({
  "content": "iVe90a_content",
  "contentScrollContainer": "iVe90a_contentScrollContainer",
  "contentWithBanner": "iVe90a_contentWithBanner",
  "cta": "iVe90a_cta",
  "frozen": "iVe90a_frozen",
  "layout": "iVe90a_layout",
  "navbarContainer": "iVe90a_navbarContainer",
  "noNav": "iVe90a_noNav",
  "sidebar": "iVe90a_sidebar",
});
